// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", ""]);
// Exports
module.exports = exports;
